import api from '../../api/axios';

export const GET_WEBHOOK_DATA_REQUEST = 'GET_WEBHOOK_DATA_REQUEST';
export const GET_WEBHOOK_DATA_SUCCESS = 'GET_WEBHOOK_DATA_SUCCESS';
export const GET_WEBHOOK_DATA_FAILURE = 'GET_WEBHOOK_DATA_FAILURE';
export const FETCH_SUBSCRIPTION_HISTORY_REQUEST = 'FETCH_SUBSCRIPTION_HISTORY_REQUEST';
export const FETCH_SUBSCRIPTION_HISTORY_SUCCESS = 'FETCH_SUBSCRIPTION_HISTORY_SUCCESS';
export const FETCH_SUBSCRIPTION_HISTORY_FAILURE = 'FETCH_SUBSCRIPTION_HISTORY_FAILURE';

export const getWebhookData = () => async (dispatch) => {
  dispatch({ type: GET_WEBHOOK_DATA_REQUEST });
  
  try {
    // Call API to get webhook data (Authorization header is attached by axios interceptor)
    const response = await api.post(`webhook/get-webhook-data`);

    const envelope = response?.data || {};
    if (envelope.success) {
      dispatch({
        type: GET_WEBHOOK_DATA_SUCCESS,
        payload: envelope || {}
      });
      return { success: true, data: envelope };
    } else {
      throw new Error(envelope.message || 'Failed to fetch webhook data');
    }
  } catch (error) {
    dispatch({
      type: GET_WEBHOOK_DATA_FAILURE,
      error: error.message || 'Failed to fetch webhook data'
    });
    return { success: false, error: error.message };
  }
};

export const fetchSubscriptionHistory = () => async (dispatch) => {
  dispatch({ type: FETCH_SUBSCRIPTION_HISTORY_REQUEST });
  
  try {
    const response = await api.get('/subscriptions/history');
    
    if (response?.data?.success) {
      dispatch({
        type: FETCH_SUBSCRIPTION_HISTORY_SUCCESS,
        payload: response.data.data || []
      });
      return { success: true, data: response.data.data };
    } else {
      throw new Error(response?.data?.message || 'Failed to fetch subscription history');
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch subscription history';
    dispatch({
      type: FETCH_SUBSCRIPTION_HISTORY_FAILURE,
      error: errorMessage
    });
    return { success: false, error: errorMessage };
  }
};
